<template>
  <div class="employer-modal-card">
    <p class="text-blue-employer-modal text-xl font-bold">{{ title }}</p>
    <p class="text-grey-employer-modal font-normal text-sm lg:text-base">{{ description }}</p>
    <input-button
        :block="true"
        class="p-0 w-fit"
        styleType="search-county-town"
        as="button"
        :href="buttonHref"
        :onClick="handleClick"
    >
      <p>{{ buttonText }}</p>
    </input-button>
  </div>
</template>

<script>
import InputButton from "Components/InputButton.vue";

export default {
  name: 'ModalCard',
  components: {InputButton},
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonHref: {
      type: String,
      default: ''
    },
  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    }
  }
}
</script>
